import CrudSalesSellingReportsGroupsData from 'components/crudSalesSellingReportsGroupsData/CrudSalesSellingReportsGroupsData'
import AssignCenterDynamicTable from 'components/genericCrud/AssignCenterDynamicTable'
import ListCrudTabContent from 'components/genericCrud/ListCrudTabContent'
import { CRUD_SALES_SELLING_REPORTS_GROUPS_DATA } from 'utils/RoutePath'

export const salesSellingReportsGroupsConfig = {
	id: 'salesSellingReportsGroupsCrud',
	key: 'cod_tipinf',
	descrip: 'descrip',
	searchMethod: 'get',
	category: 'C',
	translation: 'user_data',
	dataUrl: CRUD_SALES_SELLING_REPORTS_GROUPS_DATA,
	urlApi: 'abm_vta_tipinf',
	component: ListCrudTabContent,
	tabsList: [
		{
			key: 'basic',
			title: 'CRUDS.general_use.basic_tab',
			tabComponent: CrudSalesSellingReportsGroupsData
		},
		{
			key: 'vouchers_tab',
			title: 'CRUDS.general_use.vouchers_tab',
			urlApi: 'abm_vta_tipinf_comprobantes',
			tabId: 'cod_tipinf',
			valueId: 'nicompcc',
			tabComponent: AssignCenterDynamicTable
		}
	],
	tabsGroups: ['grilla', 'grupo.comprob'],
	tabsGroupsAlta: ['grilla', 'grupo.comprob']
}
